var HyperLinkSupport = require("enyo-ui/HyperLinkSupport"),
    IconButton       = require("app/ui/IconButton"),
    get              = require("object-path").get,
    icons            = require("app/theme/icons"),
    kind             = require("enyo/kind");

require("app/theme/IconButton--radiant.less");

module.exports = kind(/** @lends  app.MediaPlayer.PrevNextButton.prototype */ {

    /**
     * @private
     */
    name: "app.MediaPlayer.PrevNextButton",

    /**
     * @private
     */
    kind: IconButton,

    /**
     * @private
     */
    classes: "app-media-player-prev-next-button",

    /**
     * @private
     */
    mixins: [HyperLinkSupport],

    /**
     * @type  {string}
     * @public
     */
    theme: "radiant",

    /**
     * @type  {?string}
     * @public
     */
    prevCaption: null,

    /**
     * @type  {?string}
     * @public
     */
    prevIcon: icons["app.MediaPlayer.PrevNextButton.prevIcon"],

    /**
     * @type  {?string}
     * @public
     */
    nextCaption: null,

    /**
     * @type  {?string}
     * @public
     */
    nextIcon: icons["app.MediaPlayer.PrevNextButton.nextIcon"],

    /**
     * The navigation direction.
     *
     * Supported directions:
     *  - `prev`
     *  - `next`
     *
     * @type     {string}
     * @default  `next`
     * @public
     */
    direction: "next",

    /**
     * The mediaItem
     *
     * @type  {?Object}
     * @public
     */
    mediaItem: null,

    /**
     * @private
     */
    status: "no-media",

    /**
     * @private
     */
    handlers: {
        ontap: "onHyperlinkTap"
    },

    /**
     * @private
     */
    observers: {
        update: ["mediaItem"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.observe("app.$.state.mediaPlayerMediaId", this.update);

            // Unlike many other components, we don't throttle the update cycle
            // of this one. We need changes to dimensions and visibility to be
            // instant, so parent components can respond and adjust their
            // layout.
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var $appState          = this.app.$.state,
            mediaPlayerMediaId = $appState.get("mediaPlayerMediaId"),
            mediaItem          = this.get("mediaItem"),
            direction          = this.get("direction") || "next";

        this.set("href", get(mediaItem, "links.player", null));

        // No media
        if (!mediaItem) {
            this.hide();
            this.set("icon", null);
            this.set("caption", null);
            this.set("status", "no-media");
        }

        // Media player is already playing our media item
        else if (mediaPlayerMediaId === mediaItem.id) {
            this.hide();
            this.set("icon", null);
            this.set("caption", null);
            this.set("status", "no-media");
        }

        // We have a new item
        else {
            switch (direction) {
                case "next":
                    this.set("icon", this.get("nextIcon"));
                    this.set("caption", this.get("nextCaption"));
                    break;
                case "prev":
                    this.set("icon", this.get("prevIcon"));
                    this.set("caption", this.get("prevCaption"));
                    break;
                default:
                    break;
            }
            this.set("status", "new-media");
            this.show();
        }
    },

    /**
     * @private
     */
    statusChanged: function() {
        this.setAttribute("data-status", this.get("status") || null);
    },

    /**
     * Responds to a click on a hyperlink.
     *
     * @return  {boolean}  Stop propagation
     * @public
     */
    onHyperlinkTap: function() {
        var $appState           = this.app.$.state,
            $mediaPlayerManager = this.app.$.mediaPlayerManager,
            displayMode         = $appState.get("mediaPlayerDisplayMode"),
            mediaItem           = this.get("mediaItem"),
            mediaPlayer;

        // No href available
        if (!mediaItem) {
            return true;
        }

        switch (displayMode) {
            case "minimized":
                // Always navigate to the mediaItem
                $mediaPlayerManager.userNavToMediaItem(mediaItem);
                break;
            case "footer":
            case "maximized":
            default:
                // Same item but paused. Start playing it.
                if ($mediaPlayerManager.playerHasSameMediaItem(mediaItem)) {
                    if (!$appState.get("mediaPlayerPlaying")) {
                        mediaPlayer = $appState.get("mediaPlayer");

                        mediaPlayer
                            && mediaPlayer.play
                            && mediaPlayer.play();
                    }
                }

                // Different mediaItem, navigate to it
                else {
                    $mediaPlayerManager.userNavToMediaItem(mediaItem);
                }
                break;
        }

        return true;
    }

});
